import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import { store } from "./store";

import { Provider } from "react-redux";

import "./main.less";

import "echarts-gl";

import "virtual:uno.css";

// import { PersistGate } from 'redux-persist/integration/react';
// import { persistStore } from 'redux-persist';

// let persistor = persistStore(store);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  // <React.StrictMode>

  <Provider store={store}>
    {/* <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate> */}

    <App />
  </Provider>,

  // </React.StrictMode>
);
